import React, { ReactNode } from 'react'

/**
 * This component checks if the condition prop is true to validate
 * if the wrapper should load, otherwise, it will only return the children.
 */
const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}: {
  condition: boolean
  wrapper: (children: ReactNode) => JSX.Element
  children: ReactNode
}) => (condition ? wrapper(children) : <>{children}</>)

export default ConditionalWrapper
